import { commitMutation } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import { newEvent, ERROR } from '../../notifications';

const mutation = graphql`
mutation deleteMeetingMutation(
  $input: DeleteMeetingInput!
) {
  deleteMeeting(input: $input)
  {
    errors {
      key
      message
      reason
    }
    meeting {
      id
      userId
      domainId
    }
  }
}
`;

// FIXME
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
function maybeNotifyError(response) {
  let inError = false;

  if (response && response.deleteMeeting.errors !== null) {
    inError = true;
  }
  if (!response) {
    inError = true;
  }

  if (inError) {
    newEvent(ERROR, 'deleteMeetingError', 'deleteMeetingError',
      "Delete meeting error");
  }
}

// FIXME
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
function deleteMeeting(environment, id, userId, domainId) {
  return new Promise((resolve, reject) => {
    const variables = {
      input: {
        meeting: {
          userId,
          domainId,
          id
        }
      },
    };
    commitMutation(
      environment,
      {
        mutation,
        variables,
        onCompleted: (response, errors) => {
          if (errors) {
            maybeNotifyError(null);
            return reject(errors);
          }
          maybeNotifyError(response);
          return resolve(response);
        },
        onError: err => {
          maybeNotifyError(null);
          reject(err);
        }
      },
    );
  });
}

export { deleteMeeting };
